import { Formik, FormikProps } from 'formik';

import useBankValidation from 'src/hooks/useBankValidation';
import { PaymentDetailsFormValues } from 'src/types/ViewPartner/EditPaymentDetails';

import EditPaymentDetailsForm from './components';

export interface EditPaymentDetailsModalContentProps {
    handleClose: () => void;
    handleAction: () => void;
    message: string;
    buttonText?: string;
    closeModalButtonText?: string;
    initialValues?: PaymentDetailsFormValues;
    handleFormSubmit?: (values: PaymentDetailsFormValues) => void;
}

const EditPaymentDetailsModalContent = ({
    handleClose,
    message,
    buttonText,
    closeModalButtonText = 'Cancel',
    initialValues,
    handleFormSubmit,
}: EditPaymentDetailsModalContentProps) => {
    const defaultInitialValues: PaymentDetailsFormValues = {
        bic: '',
        iban: '',
        ...initialValues,
    };

    const { validateIBANAndBIC } = useBankValidation();

    const isFormValid = async (data: PaymentDetailsFormValues) => {
        const errors = await validateIBANAndBIC(data.iban.toUpperCase(), data.bic.toUpperCase(), 'iban', 'bic');
        return Object.keys(errors).length === 0;
    };

    return (
        <Formik<PaymentDetailsFormValues>
            initialValues={defaultInitialValues}
            onSubmit={async (values) => {
                const isValid = await isFormValid(values);
                if (isValid) {
                    handleFormSubmit?.(values);
                    handleClose();
                }
            }}
        >
            {(formikProps: FormikProps<PaymentDetailsFormValues>) => {
                return (
                    <EditPaymentDetailsForm
                        handleChange={formikProps.handleChange}
                        handleSubmit={formikProps.handleSubmit}
                        values={formikProps.values}
                        handleClose={handleClose}
                        message={message ?? 'Enter new bank details'}
                        buttonText={buttonText}
                        closeModalButtonText={closeModalButtonText}
                    />
                );
            }}
        </Formik>
    );
};

export default EditPaymentDetailsModalContent;
